import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "mst_token";

export const auth = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  isLoggedIn: () => !!localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const authHeaders = () => ({
  headers: { Authorization: `Bearer ${auth.getToken()}` },
});

export const api = {
  // ---- auth ----
  login: async (username, password) => {
    const res = await axios.post(`${API}/admin/login`, { username, password });
    auth.setToken(res.data.token);
    return res.data;
  },
  logout: () => auth.clear(),
  changePassword: (old_password, new_password) =>
    axios
      .post(`${API}/admin/change-password`, { old_password, new_password }, authHeaders())
      .then((r) => r.data),

  // ---- homepage ----
  getHomepage: () => axios.get(`${API}/homepage`).then((r) => r.data),
  updateHomepage: (data) =>
    axios.put(`${API}/homepage`, data, authHeaders()).then((r) => r.data),

  // ---- common ----
  getCommon: () => axios.get(`${API}/common`).then((r) => r.data),
  updateCommon: (data) =>
    axios.put(`${API}/common`, data, authHeaders()).then((r) => r.data),

  // ---- results ----
  getResults: () => axios.get(`${API}/results`).then((r) => r.data),
  addResult: (data) =>
    axios.post(`${API}/results`, data, authHeaders()).then((r) => r.data),
  bulkImportResults: (items) =>
    axios.post(`${API}/results/bulk`, items, authHeaders()).then((r) => r.data),
  updateResult: (id, data) =>
    axios.put(`${API}/results/${id}`, data, authHeaders()).then((r) => r.data),
  deleteResult: (id) =>
    axios.delete(`${API}/results/${id}`, authHeaders()).then((r) => r.data),

  // ---- auto ----
  getAnalytics: () => axios.get(`${API}/analytics`).then((r) => r.data),
  getPredict: () => axios.get(`${API}/predict`).then((r) => r.data),
  getCalendar: (date) =>
    axios.get(`${API}/calendar`, { params: { date } }).then((r) => r.data),
};

export default api;
